import StatusBadge from "components/badge/StatusBadge";

export const localityOverviewColumns = [
  {
    Header: 'Title',
    accessor: 'title',
    Cell: ({ value }) => <span>{value}</span>,
  },
  {
    Header: 'Location Slug',
    accessor: 'location_slug',
    Cell: ({ value }) => (
            <a
            _hover={{ textDecoration: 'underline' }}
            href={`${process.env.REACT_APP_HEXAHOME_BASE_URL}/${value}`}
            target="_blank"
            rel="noreferrer"
            cursor="pointer"
            whiteSpace={'nowrap'}
            style={{ fontSize: '11px', fontWeight: 600, textAlign: 'left' }}
          >
            {value}
          </a>
    ),
  },
  {
    Header: 'Editable',
    accessor: 'is_editable',
    Cell: ({ value }) => (
      <StatusBadge status={value ? 'YES' : 'NO'} />
    ),
  },
  {
    Header: 'Created By',
    accessor: 'created_by',
    Cell: ({ value }) => (
      <span>
        {value ? `${value.first_name || ''} ${value.last_name || ''}`.trim() : ''}
      </span>
    ),
  },
  {
    Header: 'Phone',
    accessor: 'created_by.phone',
    Cell: ({ value }) => <span>{value}</span>,
  },
];